import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { Automobilia } from '../models/automobilia.model';
import { HttpResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AutomobiliaService {

  private _automobilia: BehaviorSubject<Automobilia[]> = new BehaviorSubject([]);
  public readonly automobilia: Observable<Automobilia[]> = this._automobilia.asObservable();

  constructor(private api: ApiService) {
    this.loadAutomobilia();
  }

  loadAutomobilia() {
    this.api.getAutomobilia().subscribe((automobilia: Automobilia[]) => this._automobilia.next(automobilia));
  }

  saveAutomobilia(automobilia: Automobilia): Promise<any> {
    return new Promise((resolve, reject) => {
      if (automobilia.id) {
        this.api.putData('automobilia', automobilia).subscribe((result: HttpResponse<any>) => {
          this.loadAutomobilia();
          resolve(result.body as Automobilia);
        }, error => {
          this.loadAutomobilia();
          reject(error);
        });
      } else {
        this.api.postData('automobilia', automobilia).subscribe((result: HttpResponse<any>) => {
          this.loadAutomobilia();
          resolve(result.body as Automobilia);
        }, error => {
          this.loadAutomobilia();
          reject(error);
        });
      }
    });
  }

  saveAutomobiliaFiles(automobilia: Automobilia, files: File[]): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      if (automobilia.id && files) {
        files.forEach((file, fileIndex) => {
          const fileFormData = new FormData();
          fileFormData.append('file', file);
          this.api.postData('automobilia-image/' + automobilia.id, fileFormData).subscribe(result => {
            if (fileIndex + 1 === files.length) {
              this.loadAutomobilia();
              resolve(result);
            }
          }, error => {
            this.loadAutomobilia();
            reject(error);
          });
        });
      } else {
        reject('not automobilia id');
      }
    });
  }

  deleteAutomobilia(automobilia: Automobilia): Promise<any> {
    return new Promise((resolve, reject) => {
      this.api.deleteData('automobilia/' + automobilia.id).subscribe(result => {
        this.loadAutomobilia();
        resolve(result);
      }, error => {
        this.loadAutomobilia();
        reject(error);
      });
    });
  }

  deleteAutomobiliaImages(automobiliaId: number, imageIds: number[]): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      imageIds.forEach((imageId, imageIndex) => {
        this.api.deleteData('automobilia-image/' + automobiliaId + '/' + imageId).subscribe(res => {
          console.log('deleted image with id', imageId);
          if (imageIds.length === imageIndex + 1) {
            this.loadAutomobilia();
            resolve();
          }
        });
      });
    });
  }
}
